/**
 * Диспетчер сервисов автокомплита адресов.
 * Определяет, какой сервис использовать для автокомплита в зависимости от страны города старта:
 */
export async function placesOnKendoFiltering(e: kendo.ui.ComboBoxFilteringEvent): Promise<void> {
    if (window.isRussianCity) {
        await window.BackDadataService.onKendoFiltering(e);
    }
    else {
        await window.BackPlacesService.onKendoFiltering(e);
    }
}

window.placesOnKendoFiltering = placesOnKendoFiltering;
